import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import * as React from 'react';
import { ConversationDetailsLayout } from 'components/conversationsOverview/components/ConversationDetails/ConversationDetailsLayout';
import styles from '../ConversationDetails.module.scss';
export const NewMessageIndicator = ({ newMessageCount, layout, }) => {
    return (_jsx("div", Object.assign({ className: classnames({
            [styles.newMessages]: true,
            [styles.newMessagesShow]: !!newMessageCount,
            [styles.newMessagesCollapsed]: layout === ConversationDetailsLayout.SidebarCollapsed,
        }) }, { children: newMessageCount })));
};
